import type { FaireProductEntity } from "../../entity_types/product";

export const p_9nj4asytfx: FaireProductEntity = {
  token: "p_9nj4asytfx",
  type: "product",
  name: "El Rudo Salsa Macha / Chili Oil Sauce (Food Service Size)",
  brandToken: "b_8k3spdpm72",
  brandName: "El Rudo Gourmet Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/f0e0fb8678496a8f2567e84ab077b59bc943fce963de9c0a43ca6ef577ad5234.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ef87b56bdbd179c361c3ee6acfbb91aa410e775d4360d1ee5bbb19f86bba0f3.png",
    "https://cdn.faire.com/fastly/9ab552cb589a4a1c3854fe3b24e04c14c4c03417f204e8befc964a78071eaf4d.jpeg",
    "https://cdn.faire.com/fastly/9ee73d47acc3acce31675c71d9e03ea57d2c47ede9afa5540412696ba47b3bdb.png",
    "https://cdn.faire.com/fastly/28fec6b604701e18340de02ad5cb1eed4edefdddde720a04820a8cf608ef25a6.png",
    "https://cdn.faire.com/fastly/44b43f28d749fa1ee9f7835c5f80898f7c83c1a82adef67c0d67a7f982ceffa3.png",
  ],
  priceDollars: 37.99,
  description:
    "Available in bulk, El Rudo Salsa Macha brings its signature crunch, heat, and umami-rich depth to professional kitchens. Perfect for restaurants and caterers, this versatile chili oil sauce enhances marinades, glazes, dressings, soups, and more. Choose Original for balanced heat or Hot for an extra kick!\n\nEndless Culinary Uses\n✔ Marinate proteins – chicken, beef, pork, seafood\n✔ Toss & glaze – wings, ribs, roasted veggies\n✔ Enhance sauces & soups – aiolis, broths, noodles\n✔ Drizzle & garnish – tacos, pizza, rice bowls\n\nPremium Packaging\n✔ Screw Top Pail – easy access & resealing\n✔ Vacuum Tight – protects fine ingredients\n✔ Tamper-Evident – secure with cable ties\n✔ Moisture-Resistant – neoprene gasket lid\n✔ FDA Compliant & BPA-Free\n\nStock up and turn up the heat with El Rudo – Original or Hot!",
  tags: [],
  msrpDollars: 75.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:14.844Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
